module.exports = __webpack_public_path__ + "img/netflix-clone.f68dbffc.png";